import blockCategories from "./categories";
import headingIcon from "./heading/cms-icon";
import { Button } from "./button";
import { Code } from "./code";
import { Column } from "./column";
import { Columns } from "./columns";
import { Container } from "./container";
import { CountUp } from "./count-up";
import { CustomHtml } from "./custom-html";
import { FAQ } from "./faq";
import { GoogleMap } from "./google-map";
import { Icon } from "./icon";
import { Image } from "./image";
import { InnerTab } from "./inner-tab";
import { List } from "./list";
import { Navigation } from "./navigation";
import { Page } from "./page";
import { PostAuthor } from "./post-author";
import { PostContent } from "./post-content";
import { PostDate } from "./post-date";
import { PostExcerpt } from "./post-excerpt";
import { PostFeaturedImage } from "./post-featured-image";
import { PostTitle } from "./post-title";
import { Quote } from "./quote";
import { SiteLogo } from "./site-logo";
import { SiteTitle } from "./site-title";
import { Spacer } from "./spacer";
import { StarRating } from "./star-rating";
import { Tab } from "./tab";
import { Table } from "./table";
import { Text } from "./text";
import { SocialLinks } from "./social-links";
import { CMS } from "./cms";
import { Separator } from "./separator/render";
import { Search } from "./search";
import { ScrollToTop } from "./scroll-to-top";
import { Youtube } from "./youtube";
import { Twitter } from "./twitter";
import { Video } from "./video/render";
import { CMSTemplate } from "./cms-template";
import { PostCategories } from "./post-categories";
import { PostTimeToRead } from "./post-time-to-read";
import { Newsletter } from "./newsletter";
import { Lottie } from "./lottie";
import { Category } from "./category";
import { CategoryTemplate } from "./category-template";
import { Form } from "./form";
import { FormText } from "./form-text";
import { FormToggle } from "./form-toggle";
import { FormTextarea } from "./form-textarea";
import { FormDropdown } from "./form-dropdown";
import { FormRange } from "./form-range";
import { FormDate } from "./form-date";
import { FormOption } from "./form-option";
import { FormCheckbox } from "./form-checkbox";
import { FormGoogleRecaptcha } from "./form-google-recaptcha";
import { FormSuccess } from "./form-success";
import { FormFail } from "./form-fail";
import { FormSubmit } from "./form-submit";
import { Portal } from "./portal";
import { PortalClose } from "./portal-close";
import { TableOfContents } from "./table-of-contents";
import { Slider } from "./slider";
import { ProductHunt } from "./product-hunt";
import { Dropdown } from "./dropdown";
import { ContentLockerInline } from "./content-locker-inline";
import { ContentLockerPopup } from "./content-locker-popup";
import { Directory } from "./directory";
import { DirectoryTemplate } from "./directory-template";

const coreBlocks = [
  Text,
  List,
  Image,
  Table,
  Quote,
  FAQ,
  Code,
  Video,
  Separator,
  Button,
  Container,
  CustomHtml,
  Columns,
  Column,
  CountUp,
  GoogleMap,
  Icon,
  InnerTab,
  Page,
  CMS,
  CMSTemplate,
  Directory,
  DirectoryTemplate,
  Category,
  CategoryTemplate,
  PostTitle,
  PostFeaturedImage,
  PostAuthor,
  PostExcerpt,
  PostContent,
  PostDate,
  PostTimeToRead,
  TableOfContents,
  SiteLogo,
  SiteTitle,
  Navigation,
  Spacer,
  StarRating,
  Tab,
  PostCategories,
  ScrollToTop,
  Portal,
  PortalClose,
  Search,
  SocialLinks,
  Twitter,
  Youtube,
  Form,
  FormSuccess,
  FormFail,
  FormText,
  FormDropdown,
  FormCheckbox,
  FormToggle,
  FormOption,
  FormRange,
  FormTextarea,
  FormDate,
  FormGoogleRecaptcha,
  FormSubmit,
  Lottie,
  Newsletter,
  Slider,
  ProductHunt,
  Dropdown,
  ContentLockerInline,
  ContentLockerPopup,
];

var blocksLibrary = coreBlocks.reduce(function (obj, x) {
  if (x?.craft?.custom?.slug) {
    obj[[x.craft.custom.slug]] = x;
  }
  return obj;
}, {});

var blockResolvers = coreBlocks.reduce(function (obj, x) {
  if (x?.displayName) {
    obj[[x.displayName]] = x;
  }
  return obj;
}, {});

var blockCategoryMapping = coreBlocks.reduce(function (obj, x) {
  if (x?.craft?.custom?.slug) {
    const blockCategory = x?.craft?.related?.category
      ? x?.craft?.related?.category
      : "miscellaneous";
    (obj[[blockCategory]] || (obj[[blockCategory]] = [])).push(
      x.craft.custom.slug,
    );
  }
  return obj;
}, {});

var blockKeywords = coreBlocks.reduce(function (obj, x) {
  if (x?.craft?.custom?.slug && x?.craft?.related?.keywords) {
    if (!x?.craft?.related?.isHiddenInPostEditor) {
      obj[[x.craft.custom.slug]] = {
        label: x?.craft?.name,
        keywords: x?.craft?.related?.keywords,
        icon: x?.craft?.related?.CMSIcon,
      };
    }
  }
  return obj;
}, {});

blockKeywords = {
  "grigora/heading": {
    label: "Heading",
    keywords: ["Heading"],
    icon: headingIcon,
  },
  ...blockKeywords,
};

export {
  blocksLibrary,
  blockCategories,
  blockResolvers,
  blockCategoryMapping,
  blockKeywords,
};
